import { Tooltip } from "antd";
import React, { ReactNode } from "react";
import { IUI_ITOTooltipProps } from "../../interfaces/Ui/IUI_ITOTooltip/IUI_ITOTooltipProps";

// текст при наведении
export const UI_ITOTooltip: React.FC<IUI_ITOTooltipProps> = ({
  title,
  children,
  isOpen,
}) => {
  return (
    <Tooltip
      title={ title }
      open={ isOpen }
      color="#fff"
      styles={{ body: { color: "#000" } }}
    >
      {children}
    </Tooltip>
  );
};
